export default __webpack_public_path__ + "static/media/Superdick.f88c865a.png";